module.exports = __webpack_public_path__ + "img/r2.c92a54de.png";